/**
 * Checks if two URLs have the same origin.
 *
 * @param a URL or string
 * @param b URL or string
 * @returns true if both URLs are the same origin, false otherwise
 */
export function areSameOrigin(a: string | URL, b: string | URL) {
  let aUrl: URL;
  let bUrl: URL;

  if (typeof a === 'string') {
    aUrl = new URL(a);
  } else {
    aUrl = a;
  }

  if (typeof b === 'string') {
    bUrl = new URL(b);
  } else {
    bUrl = b;
  }

  return aUrl.origin === bUrl.origin;
}
